import React from "react";

function AboutSection() {
  return (
    <section className="about_section">
      {/* <div style={{
        maxWidth: 1135,
        margin: "5rem auto",
        padding: "0 1rem"
      }}>

      <h2>About Us</h2>
          <p>
            Welcome to Asakaa Play, your trusted partner in sports predictions.
            We're a dedicated team of football enthusiasts, statisticians, and data
            analysts committed to providing top-notch betting predictions. Our goal
            is to help you make informed decisions and increase your chances of
            winning through data-driven insights and expert analysis.
          </p>

          <p>
            Our expert analysts use advanced statistical models, machine learning
            algorithms, and in-depth knowledge of football to analyze matches across
            various leagues. With years of experience in sports analysis, our team
            monitors over 50 leagues worldwide to bring you the most accurate
            predictions.
          </p>
      </div> */}

      <div className="ab_container">
        <div className="ab_img">
          <img src="/images/about2.jpg" alt="" />
        </div>
        <div className="about_content">
            <div className="about_text">
              <h2>Introducing Our Worlds</h2>
              <p>
                The Bigger the sports event the more interest, excitement and
                media attention on the action. And the more betting markets we
                have available here at Asakaaplay to turn your opinions into
                winning bets. Bigger sports event coming up!!.
              </p>
            </div>
            <a href="/predictions/premium" className="about-btn">
              Subscribe to us
            </a>
        </div>
      </div>

      {/* <div className="about_container">
        
        <img src="images/about.jpg" alt="about" style={{
          borderRadius: 50
        }} />

        <div className="about_content">
          

          <h3>Our Services</h3>
          <ul>
            <li>
              <p>
                <b>Match Predictions:</b> Accurate forecasts for match outcomes based
                on comprehensive team analysis, historical data, and current form.
              </p>
            </li>
            <li>
              <p>
                <b>Correct Score:</b> Precise predictions for the exact final score
                using advanced statistical models.
              </p>
            </li>
            <li>
              <p>
                <b>Over/Under Goals:</b> Detailed analysis of expected goal patterns
                and scoring trends.
              </p>
            </li>
            <li>
              <p>
                <b>Both Teams to Score (BTTS):</b> In-depth analysis of team scoring
                patterns and defensive capabilities.
              </p>
            </li>
          </ul>

          <h3>Why Choose Us?</h3>
          <ul>
            <li>
              <p>
                <b>Data-Driven Analysis:</b> Our predictions are based on
                comprehensive statistical analysis and real-time data.
              </p>
            </li>
            <li>
              <p>
                <b>Expert Team:</b> Experienced analysts with deep knowledge of
                football and betting markets.
              </p>
            </li>
            <li>
              <p>
                <b>Global Coverage:</b> Analysis of matches from major and minor
                leagues worldwide.
              </p>
            </li>
            <li>
              <p>
                <b>Regular Updates:</b> Daily predictions and tips to keep you
                informed.
              </p>
            </li>
          </ul>

          <p className="disclaimer">
            Remember: While we strive for accuracy in our predictions, sports betting
            involves risks. Always gamble responsibly and within your means.
          </p>
        </div>
      </div> */}
    </section>
  );
}

export default AboutSection;
